import { z } from 'zod'

import { agentTypeItems } from '../agent-type'

/** Zod schema for validating agent pool configuration. */
export const agentPoolSchema = z.object({
  agents: z.array(z.number()),
  name: z.string().min(1, 'Name is required').max(255, 'Name must be less than 255 characters'),
  type: z.enum(agentTypeItems),
})
